var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvalidSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58371 0 0 3.58371 0 8C0 12.4163 3.58371 16 8 16C12.4163 16 16 12.4163 16 8C16 3.58371 12.4163 0 8 0ZM10.3529 8.50679L11.6923 9.84615C11.9457 10.0995 11.9457 10.5339 11.6923 10.8235L10.7873 11.7285C10.5339 11.9819 10.0995 11.9819 9.80995 11.7285L8.47059 10.3891C8.21719 10.1357 7.78281 10.1357 7.49321 10.3891L6.15385 11.7285C5.90045 11.9819 5.46606 11.9819 5.17647 11.7285L4.27149 10.8235C4.0181 10.5701 4.0181 10.1357 4.27149 9.84615L5.61086 8.50679C5.86425 8.25339 5.86425 7.819 5.61086 7.52941L4.27149 6.19005C4.0181 5.93665 4.0181 5.50226 4.27149 5.21267L5.17647 4.30769C5.42986 4.0543 5.86425 4.0543 6.15385 4.30769L7.49321 5.64706C7.74661 5.90045 8.181 5.90045 8.47059 5.64706L9.80995 4.30769C10.0633 4.0543 10.4977 4.0543 10.7873 4.30769L11.6923 5.21267C11.9457 5.46606 11.9457 5.90045 11.6923 6.19005L10.3529 7.52941C10.0995 7.78281 10.0995 8.21719 10.3529 8.50679Z",
    fill: "#FF101F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidSvg);
export default __webpack_public_path__ + "static/media/InvalidSVG.68e02f64.svg";
export { ForwardRef as ReactComponent };